import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import Gallery from '../components/layout/Gallery';
import VideoReel from '../components/layout/VideoReel';
import About from '../components/layout/About';
import Contact from '../components/layout/Contact';
import Footer from '../components/layout/Footer';
import IrisTransition from '../components/hero/IrisTransition';
import IrisEmberBurst from '../components/hero/IrisEmberBurst';
import EmberField from '../components/hero/EmberField';
import HoverGas from '../components/shared/HoverGas';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_picturegallery-1/artifacts/ds0tfjjj_Kelvin%20the%20Kreator%20Logo.png';

export default function PortfolioPage() {
  const location = useLocation();
  const [iris, setIris] = useState(() => (sessionStorage.getItem('xp-arrive-iris') ? 'opening' : null));
  const [burst, setBurst] = useState(() => Boolean(sessionStorage.getItem('xp-arrive-iris')));

  useLayoutEffect(() => {
    const id = location.hash.replace('#', '');
    const jump = () => {
      const el = id && document.getElementById(id);
      if (el) {
        const top = el.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top, behavior: 'auto' });
      } else if (!id) {
        window.scrollTo(0, 0);
      }
    };
    requestAnimationFrame(jump);
    const timers = [400, 1200].map((ms) => setTimeout(jump, ms));
    return () => timers.forEach(clearTimeout);
  }, [location.hash]);

  useEffect(() => {
    if (iris === 'opening') {
      sessionStorage.removeItem('xp-arrive-iris');
      const t = setTimeout(() => setIris(null), 850);
      return () => clearTimeout(t);
    }
  }, [iris]);

  return (
    <div className="portfolio-page" data-testid="portfolio-page">
      <header className="xp-topbar" data-testid="portfolio-topbar">
        <EmberField stream count={26} />
        <Link to="/" className="xp-topbar-logo" data-testid="portfolio-home-logo" aria-label="Back to home">
          <img src={LOGO_URL} alt="Kelvin the Kreator logo" draggable={false} />
        </Link>
        <Link to="/" className="xp-topbar-back" data-testid="portfolio-back-link" data-gas>
          <span className="xp-topbar-arrow">&larr;</span>
          Back to the experience
        </Link>
      </header>
      <HoverGas />
      <main className="portfolio-page-main">
        <Gallery />
        <VideoReel />
        <About />
        <Contact />
      </main>
      <Footer />
      <IrisTransition phase={iris} />
      {burst && <IrisEmberBurst onDone={() => setBurst(false)} />}
    </div>
  );
}
